import { render, staticRenderFns } from "./tip-1.vue?vue&type=template&id=e7108212&scoped=true"
import script from "./tip-1.vue?vue&type=script&lang=js"
export * from "./tip-1.vue?vue&type=script&lang=js"
import style0 from "./tip-1.vue?vue&type=style&index=0&id=e7108212&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7108212",
  null
  
)

export default component.exports